import createKeys from '../../utilities/createKeys'

export const Keys = createKeys('WORKING_PERIODS', ['PERIOD', 'FILTROS'])
